import React, { memo } from 'react';
import Header from 'containers/components/layouts/Header';
import HeaderTitle from 'containers/components/layouts/HeaderTitle';
import HeaderSection from 'containers/components/layouts/HeaderSection';
import HeaderSectionDefault from 'containers/components/layouts/HeaderSectionDefault';
import { SALESORDERS } from 'constants/Entities';

const SalesOrdersHeader = memo(() => {
    return (
        <Header>
            <HeaderSection>
                <HeaderTitle
                    title="title_orders"
                    addonName="addon_salesorders"
                    entity={SALESORDERS}
                    withTrialBadge
                />
            </HeaderSection>
            <HeaderSectionDefault />
        </Header>
    );
});

export default SalesOrdersHeader;
